import { isAdmin, isSuperAdmin } from 'lib/utils/auth'
import { ALL_ORGS_SELECTED } from 'lib/constants'
import { CenteredLoader, PageWrapper, ViewWrapper } from 'components/widgets'
import { trans, TranslationGroup } from 'lib/types'
import { useGlobal } from 'contexts/GlobalProvider'

function AdminRequired(props: any) {
  const translation: TranslationGroup = trans.admin()
  const { selectedOrg, selectedOrgId, loading } = useGlobal()

  // While global state or the selected org is still resolving (e.g. on a hard
  // refresh, before the org is hydrated from storage), show a loader instead of
  // briefly flashing the "please select an organization" message.
  const orgResolving =
    loading ||
    (!!selectedOrgId && selectedOrgId !== ALL_ORGS_SELECTED && selectedOrg?.id !== selectedOrgId)

  const location = selectedOrg
  const allowed = isSuperAdmin() || (location && location.name !== ALL_ORGS_SELECTED && isAdmin(location.id))

  return (
    <PageWrapper>
      <ViewWrapper>
        {orgResolving ? <CenteredLoader /> : allowed ? props.children : <>{translation.admin_required}</>}
      </ViewWrapper>
    </PageWrapper>
  )
}

export default AdminRequired
